import { Text, Button } from "@chakra-ui/react";
import { ChevronUpIcon } from "@chakra-ui/icons";
import { orderSummaryOpenAtom, selectedTicketAtom } from "utils/atoms";
import { useAtom } from "jotai";

const TicketingModalExpandableButton = () => {
  const [selectedTicket] = useAtom(selectedTicketAtom);
  const [, setOrderSummaryOpen] = useAtom(orderSummaryOpenAtom);

  return (
    <div className="md:hidden py-0 sm:py-4">
      <Button
        fontSize="lg"
        px="1.5rem"
        //py="0.70rem"
        color="white"
        backgroundColor="transparent"
        fontWeight="bold"
        borderRadius="6.25rem"
        variant="transparent"
        onClick={() => setOrderSummaryOpen(true)}
        disabled={!selectedTicket}
      >
        <div
          className={`transition-opacity duration-500 ${
            !selectedTicket && "opacity-0"
          }`}
        >
          <ChevronUpIcon w={30} h={30} />
        </div>
        <Text ml={1}>
          $ {selectedTicket ? selectedTicket.payableToFixed : "0.00"}
        </Text>
      </Button>
    </div>
  );
};

export default TicketingModalExpandableButton;
